'use es6';

const getRoot = state => state.legalConsent;
export function getSubscriptionDefinitions(state) {
  return getRoot(state).subscriptionDefinitions;
}
export function getConsentCopy(state) {
  return state.legalConsent.consentCopy;
}